import { render, staticRenderFns } from "./OrderItemsPlacedStackedBarChart.vue?vue&type=template&id=cb1e4950"
import script from "./OrderItemsPlacedStackedBarChart.vue?vue&type=script&lang=js"
export * from "./OrderItemsPlacedStackedBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports